import { IMoveToProjectParams } from '../types/IMoveToProjectParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class MoveFlowsToProjectRequest extends Request<IMoveToProjectParams, IResult> {
  constructor(params: IMoveToProjectParams) {
    super('moveFlowsToProject', params);
  }
}
